import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Phishing = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 4.38C19 3.07 17.93 2 16.62 2C15.31 2 14.24 3.07 14.24 4.38C14.24 5.47 14.99 6.38 15.99 6.66V16.37C15.99 18.78 13.81 20.75 11.12 20.75C8.43 20.75 6.25 18.79 6.25 16.37V15.91H9.73C9.97 15.91 10.2 15.77 10.3 15.55C10.4 15.33 10.36 15.07 10.21 14.88L6.1 10.11C5.93 9.91 5.65 9.84 5.41 9.93C5.16 10.02 5 10.25 5 10.52V15.29C5 15.29 5 15.29 5 15.3V16.37C5 19.48 7.75 22 11.12 22C14.49 22 17.24 19.48 17.24 16.37V6.66C18.25 6.38 18.99 5.47 18.99 4.38H19ZM6.26 14.66V12.2L8.37 14.66H6.26ZM16.62 5.5C16 5.5 15.49 5 15.49 4.37C15.49 3.74 16 3.24 16.62 3.24C17.24 3.24 17.75 3.74 17.75 4.37C17.75 5 17.24 5.5 16.62 5.5Z" />
  </svg>
)

export default withDefaultStyles(Phishing)
